import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './SegmentedControl.scss';
/**
 * @component SegmentedControl
 * @since 1.0.0
 * Mutually exclusive choice between a few options (tabs, $ / #, etc.).
 */
export function SegmentedControl(props) {
    const { label, options, value, onChange, size = 'normal' } = props;
    if (options.length < 2) {
        return null;
    }
    return (React.createElement("div", { className: classNames('segmented-control', 'segmented-control--' + size, props.className), role: "radiogroup", "aria-label": label }, options.map((option) => {
        const selected = option.value === value;
        return (React.createElement("button", { key: option.value, type: "button", role: "radio", "aria-checked": selected, className: classNames('segmented-control-option', {
                'segmented-control-option--is-selected': selected
            }), onClick: () => onChange(option.value) }, option.label));
    })));
}
